import { render, staticRenderFns } from "./AxRowFooter.vue?vue&type=template&id=68d239c0&scoped=true"
import script from "./AxRowFooter.vue?vue&type=script&lang=ts"
export * from "./AxRowFooter.vue?vue&type=script&lang=ts"
import style0 from "./AxRowFooter.vue?vue&type=style&index=0&id=68d239c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d239c0",
  null
  
)

export default component.exports